import { useState } from 'react';
import React from 'react';
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  TwitterIcon,
  TwitterShareButton,
  EmailIcon,
  FacebookIcon,
} from 'react-share';
import CopyLink from '../../images/svg-gcbooks/copyLink';

export default function ShareMenu() {
  const [showCopyToClipBoard, setShowCopyToClipBoard] = useState(false);
  let copiedUrl, shareUrl;
  if (typeof window !== 'undefined' && window.location) {
    shareUrl = window.location && window?.location?.href;
    /* Copy the text inside the text field */
  }

  const copyLinkUrl = () => {
    if (typeof window !== 'undefined' && window.location) {
      copiedUrl = window.location && window?.location?.href;
      /* Copy the text inside the text field */

      navigator.clipboard.writeText(copiedUrl);
    }
  };
  return (
    <div className="shareMenuContainer">
      <FacebookShareButton url={shareUrl}>
        <div className="socialButtonContainer">
          <i className="iconFacebook">
            <FacebookIcon size={32} round={true} />
          </i>
          <h6>Facebook</h6>
        </div>
      </FacebookShareButton>
      <FacebookMessengerShareButton url={shareUrl} appId="587097706233106">
        <div className="socialButtonContainer">
          <i className="iconFacebook">
            <FacebookMessengerIcon size={32} round={true} />
          </i>
          <h6>Messenger</h6>
        </div>
      </FacebookMessengerShareButton>
      <EmailShareButton url={shareUrl}>
        <div className="socialButtonContainer">
          <i className="iconFacebook">
            <EmailIcon size={32} round={true} />
          </i>
          <h6>Email</h6>
        </div>
      </EmailShareButton>

      <div
        className="copylinkContainer cursor-pointer"
        onClick={() => {
          copyLinkUrl();
          setShowCopyToClipBoard(true);
          setTimeout(() => setShowCopyToClipBoard(false), 1000);
        }}
      >
        <i className="copylinkIcon">
          <CopyLink />
        </i>

        <h6 className="marginl-10">Copy Link</h6>
      </div>

      <div className={showCopyToClipBoard ? 'copied-to-clipboard' : 'hide'}>
        &#x2713;<h6 id="clipboardtext">Copied to clipboard.</h6>
      </div>
    </div>
  );
}
